var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('footer',{staticClass:"app-footer"},[_c('div',{staticClass:"app-footer__row"},[_vm._t("default",function(){return [_c('div',{staticClass:"app-footer__default"},[_c('span',{staticClass:"text-lg"},[_vm._v("©T.Dev, "+_vm._s(new Date().getFullYear()))])])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }